import { MrbBaseRouteStore } from "mrb/core";
import { StationAnalyticsService, StationFileStreamService } from "common/services";
import { createBaasicAuthenticatedMediaVaultUrl } from "mrb/baasic";

class TrendingStationListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(StationAnalyticsService);
        this.stationFileStreamService = this.rootStore.createApplicationService(StationFileStreamService);
    }

    async getTrendingStations(filter) {
        const response = await this.service.getTrendingStations(filter);
        return response.data;
    }

    createStationCoverImageUrl(coverImageId, width = null, height = null) {
        return createBaasicAuthenticatedMediaVaultUrl(
            this.rootStore,
            this.stationFileStreamService.routeService.get(coverImageId),
            {
                width: width,
                height: height,
            }
        );
    }
}

export default TrendingStationListRouteStore;
